export const imgLocation = require("../assets/location.png");
export const imgLogo = require("../assets/logo.png");
export const searchDark = require("../assets/searchDark.svg");
export const searchLight = require("../assets/searchLight.svg");
